import { render, staticRenderFns } from "./EmployeeAllowance.vue?vue&type=template&id=555b9ac3"
import script from "./EmployeeAllowance.vue?vue&type=script&lang=js"
export * from "./EmployeeAllowance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports